// extracted by mini-css-extract-plugin
module.exports = {"content":"_39PGrKU6al","top":"OteZOrOhMU","width-160":"_2D8H0h44R2","marginR":"_2k1agQrJwD","edit-text":"_2bT0-qTUtl","clear-text":"_9_XoVhj7Qh","phone":"_3AdikHMF0X"};